// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { Stack } from "@fluentui/react";
import { animated, useSpring } from "@react-spring/web";

import styles from "./Answer.module.css";
import { AnswerIcon } from "./AnswerIcon";

interface Props {
    useDarkMode: boolean;
}

export const AnswerLoading = ({ useDarkMode }: Props) => {
    const animatedStyles = useSpring({
        from: { opacity: 0 },
        to: { opacity: 1 }
    });

    return (
        <animated.div style={{ ...animatedStyles }}>
            <Stack className={useDarkMode ? styles.answerContainerDark : styles.answerContainer} verticalAlign="space-between">
                <AnswerIcon useDarkMode={useDarkMode} />
                <Stack.Item grow>
                    <p className={styles.answerText}>
                        Generating answer
                        <span className={styles.loadingdots} />
                    </p>
                </Stack.Item>
            </Stack>
        </animated.div>
    );
};
